import styled from 'styled-components';
import { DropdownStyle } from '../../dropdown/model/Model';
import { InputStyle } from '../../input/model/Model';
import { DefaultText } from '../../../styles/global/css/GlobalText';
import { RedSidely, SidelyBlack } from '../../../styles/global/css/Utils';

export const creationPopupDropdownStyle: DropdownStyle = {
	width: '100%',
	containerWidth: '100%',
	containerHeight: 'fit-content',
	labelUp: true,
	optionHeight: '200px',
	optionWidth: '100%'
};

export const creationPopupInputStyle: InputStyle = {
	width: '100%',
	containerWidth: '100%',
	containerHeight: 'fit-content',
	labelUp: true,
	borderRadius: '5px'
};

export const CreationPopupContainer = styled.div<{ gap?: string, padding?: string }>`
    display: flex;
    flex-flow: column;
    height: 100%;
    padding: ${p => p.padding ?? '10px 10px 15px 10px'};
    gap: ${p => p.gap ?? '8px'};
`;

export const TitleSection = styled.p`
    ${DefaultText}
    width: 100%;
    color: ${SidelyBlack};
    font-size: 13px;
    font-weight: 500;
`;

export const Label = styled.p<{ required?: boolean }>`
    ${DefaultText}
    margin-top: 10px;

    ${p => p.required ? `&::before { content: '* '; color: ${RedSidely}; }` : ''}
`;

export const Spacer = styled.div<{ height?: number }>`
    width: 100%;
    margin: ${p => p.height ?? '5'}% 0 ${p => p.height ?? '5'}% 0;
`;
